var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("input", {
        attrs: { type: "hidden", name: "contact_id" },
        domProps: { value: _vm.value },
      }),
      _vm._v(" "),
      _c(
        "el-select",
        {
          staticClass: "form-control",
          attrs: {
            filterable: "",
            clearable: "",
            remote: "",
            placeholder: "Search",
            "remote-method": _vm.search,
            loading: _vm.loading,
            popperClass: "custom-popper",
          },
          on: { input: _vm.onInput },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: _vm.format(item), value: item.id },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }